import React, { useEffect } from "react";
import SelectionContainer from "../../../components/Pages/Premium/utils/SelectionContainer";
import UserDetails from "../../../components/Pages/Premium/UserDetails";
import { useAppContext } from "../../../_context";
import CustomContainer from "../../../components/Misc/CustomContainer";
import { events, track } from "../../../utilities/Analitycs";

function PlayerDetails() {
  const [{ tx }] = useAppContext();

  useEffect(() => {
    track(events.startFunnel);
  }, []);

  return (
    <CustomContainer>
      <SelectionContainer
        title={
          tx["Awesome! Let’s get you signed up for the RacketPal community"]
        }
        textAlign="center">
        <UserDetails />
      </SelectionContainer>
    </CustomContainer>
  );
}

export default PlayerDetails;
